const listeners = new Set();

export function onBillingRefresh(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyBillingRefresh(accountId) {
  for (const listener of listeners) listener(accountId);
}
